import { PAGE_NAME } from '../../utils/constants'
import { getUrlIdForTracking } from '../../utils/getUrlIdForTracking'

export const getTrackingConfig = (trackingData) => {
  const { ctaCopy, ctaUrl, mpvId, productKey, position, sectionHeader, subsection, row, section, pageZone, sourcePagePath } = trackingData
  const customZone = row ? `${section}_${sectionHeader}_Row${row}` : section
  const urlId = getUrlIdForTracking(ctaUrl)
  const ctaValue = urlId || ctaCopy

  const body = {
    sourcePagePath: typeof window !== 'undefined' ? window.location.pathname : '/',
    destinationPagePath: ctaUrl || '',
    pageZone: pageZone || customZone,
    ctaValue,
    mpvId,
    productKey,
    subsection,
    position: position || 0,
  }
  return trackingOutput(body)
}

const trackingOutput = ctaTrackingConfig => {
  const { destinationPagePath, ctaValue, mpvId, productKey, subSection, sourcePagePath, position, pageZone } = ctaTrackingConfig
  const { experimentId, experimentKey, variationId, variationKey } = ctaTrackingConfig
  const parsedDestinationPagePath = removeQueryParamsFrom(destinationPagePath)
  const composedCtaValue = subSection ? `${subSection}:${ctaValue}` : ctaValue
  const eventDetail = `${sourcePagePath};${parsedDestinationPagePath};${pageZone};${composedCtaValue}`
  const navigationDetail = `${composedCtaValue}:${position}`

  const eventName = 'Navigation Clicked'
  const experimentProperties =
    experimentId && variationId
      ? {
          experimentId: experimentId.toString(),
          experimentName: experimentKey,
          variationId: variationId.toString(),
          variationName: variationKey,
        }
      : {}

  return {
    eventName,
    properties: {
      category: PAGE_NAME,
      label: `Content:${pageZone}`,
      eventDetail,
      navigationDetail: pageZone === 'Hero' ? ctaValue : navigationDetail,
      product_id: mpvId,
      core_product_id: productKey,
      ...experimentProperties,
    },
    linkAttributes: {
      'data-section': `Content:${pageZone}`,
      'data-position': position,
      'data-translation': composedCtaValue,
    },
  }
}

export const getCtaTrackingConfig = ({ destinationUrl, pageZone, linkIdentifier, ctaPosition }) => {
  const sourcePagePath = typeof window !== 'undefined' ? window.location.pathname : '/'
  const parsedDestinationPagePath = removeQueryParamsFrom(destinationUrl)
  const eventDetail = `${sourcePagePath};${parsedDestinationPagePath};${pageZone};${linkIdentifier}`
  const navigationDetail =
    ctaPosition && ((typeof ctaPosition === 'number' && ctaPosition > 0) || typeof ctaPosition === 'string')
      ? `${linkIdentifier}:${ctaPosition}`
      : linkIdentifier
  return {
    eventName: 'Navigation Clicked',
    properties: {
      category: PAGE_NAME,
      label: `Content:${pageZone}`,
      eventDetail,
      navigationDetail,
    },
    linkAttributes: {
      'data-section': `Content:${pageZone}`,
      'data-position': ctaPosition,
      'data-translation': linkIdentifier,
    },
  }
}

const removeQueryParamsFrom = pagePath => {
  if (typeof window !== 'undefined') {
    return new URL(pagePath, window.location.origin).pathname
  }

  return pagePath
}

export const getTileCtaTrackingConfig = (destinationUrl, pageZone, linkIdentifier, ctaPosition) => {
  return getCtaTrackingConfig({ destinationUrl, pageZone, linkIdentifier, ctaPosition })
}

const newTileTrackingOutput = (ctaTrackingConfig) => {
  const { destinationUrl, tileHeader, mpvId, productKey, subSection, sourcePagePath, position, pageZone } = ctaTrackingConfig
  const { experimentId, experimentKey, variationId, variationKey } = ctaTrackingConfig
  const parsedDestinationPagePath = removeQueryParamsFrom(destinationUrl)
  const composedCtaValue = subSection ? `${subSection}:${tileHeader}` : tileHeader
  const eventDetail = `${sourcePagePath};${parsedDestinationPagePath};${pageZone};${composedCtaValue}`
  const navigationDetail = `${composedCtaValue}:${position}`

  const eventName = 'Navigation Clicked'
  const experimentProperties =
    experimentId && variationId
      ? {
          experimentId: experimentId.toString(),
          experimentName: experimentKey,
          variationId: variationId.toString(),
          variationName: variationKey,
        }
      : {}

  return {
    eventName,
    properties: {
      category: 'Home Page',
      label: `Content:${pageZone}`,
      eventDetail,
      navigationDetail: pageZone === 'Hero' ? tileHeader : navigationDetail,
      product_id: mpvId,
      core_product_id: productKey,
      ...experimentProperties,
    },
    linkAttributes: {
      'data-section': `Content:${pageZone}`,
      'data-position': position,
      'data-translation': composedCtaValue,
    },
  }
}

export const getNewTileTrackingConfig = (trackingData, manualExperimentImpression) => {
  const {
    destinationUrl,
    mpvId,
    tileHeader,
    productKey,
    position,
    sectionHeader,
    subsection,
    row,
    section,
    pageZone,
    sourcePagePath,
  } = trackingData
  const customZone = row ? `${section}_${sectionHeader}_Row${row}` : section
  const urlId = getUrlIdForTracking(destinationUrl)
  const ctaValue = urlId || tileHeader

  let body = {
    sourcePagePath,
    destinationUrl: destinationUrl || '',
    pageZone: pageZone || customZone,
    tileHeader: ctaValue,
    mpvId,
    productKey,
    subsection,
    position: position || 0,
  }
  if (manualExperimentImpression) {
    body = {
      ...body,
      ...manualExperimentImpression,
    }
  }
  return newTileTrackingOutput(body)
}
